import type * as SchemaTypes from '../../../../apolloClient.types';

import type { FinSwimPerformanceResultFragment, FinSwimPerformanceResultDataFragment } from '../Create/CreatePerformanceFinSwimResult.api';
import { gql } from '@apollo/client';
import { FinSwimPerformanceResultDataFragmentDoc, FinSwimPerformanceResultFragmentDoc } from '../Create/CreatePerformanceFinSwimResult.api';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdatePerformanceFinSwimResultMutationVariables = SchemaTypes.Exact<{
  id: SchemaTypes.Scalars['ObjectID']['input'];
  input: SchemaTypes.UpdateFinSwimResultInput;
}>;


export type UpdatePerformanceFinSwimResultMutation = (
  { __typename: 'Mutation' }
  & { updateFinSwimResult: (
    { __typename: 'ErrorResponse' }
    & { fields?: SchemaTypes.Maybe<Array<(
      { __typename: 'ErrorOnField' }
      & Pick<SchemaTypes.ErrorOnField, 'field' | 'message'>
    )>> }
  ) | (
    { __typename: 'UpdateFinSwimResultSuccessfulResponse' }
    & { result: (
      { __typename: 'PerformanceResult' }
      & FinSwimPerformanceResultFragment
    ) }
  ) }
);


export const UpdatePerformanceFinSwimResultDocument = /*#__PURE__*/ gql`
    mutation UpdatePerformanceFinSwimResult($id: ObjectID!, $input: UpdateFinSwimResultInput!) {
  updateFinSwimResult(id: $id, input: $input) {
    ... on UpdateFinSwimResultSuccessfulResponse {
      result {
        ...FinSwimPerformanceResult
      }
    }
    ... on ErrorResponse {
      fields {
        field
        message
      }
    }
  }
}
    ${FinSwimPerformanceResultFragmentDoc}`;
export type UpdatePerformanceFinSwimResultMutationFn = Apollo.MutationFunction<UpdatePerformanceFinSwimResultMutation, UpdatePerformanceFinSwimResultMutationVariables>;

/**
 * __useUpdatePerformanceFinSwimResultMutation__
 *
 * To run a mutation, you first call `useUpdatePerformanceFinSwimResultMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePerformanceFinSwimResultMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePerformanceFinSwimResultMutation, { data, loading, error }] = useUpdatePerformanceFinSwimResultMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePerformanceFinSwimResultMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePerformanceFinSwimResultMutation, UpdatePerformanceFinSwimResultMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePerformanceFinSwimResultMutation, UpdatePerformanceFinSwimResultMutationVariables>(UpdatePerformanceFinSwimResultDocument, options);
      }
export type UpdatePerformanceFinSwimResultMutationHookResult = ReturnType<typeof useUpdatePerformanceFinSwimResultMutation>;
export type UpdatePerformanceFinSwimResultMutationResult = Apollo.MutationResult<UpdatePerformanceFinSwimResultMutation>;
export type UpdatePerformanceFinSwimResultMutationOptions = Apollo.BaseMutationOptions<UpdatePerformanceFinSwimResultMutation, UpdatePerformanceFinSwimResultMutationVariables>;